import React from 'react';
import Hero from "./Hero.js";
import Brocrage from "./Brocrage.js";

const Pricing = () => {
  return (
    <>
    <Hero/>
    <Brocrage/>
    </>
  );
}

export default Pricing